// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryBlankPage_wrapper__TQzWE"};